import { createSlice } from "@reduxjs/toolkit"

const app = createSlice({
  name: "ligthbox",
  initialState: {
    url: null,
    visible: false,
  },
  reducers: {
    setState: (state, action) => {
      return { ...state, ...action.payload }
    },
  },
})

export const { setState } = app.actions

export default app
